import { Link } from 'react-router-dom';
import { Meta } from '@/components/seo/Meta';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <>
      <Meta title="Page not found" path="/404" />
      <section className="flex min-h-[70vh] items-center justify-center pt-20">
        <div className="container-narrow text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">404</p>
          <h1 className="mt-3 display-serif text-display-l text-fg">Lost in the stack.</h1>
          <p className="mx-auto mt-6 max-w-md text-fg-muted">
            The page you're looking for doesn't exist — or has moved. Try heading home or browsing our work.
          </p>
          <div className="mt-10 flex justify-center gap-3">
            <Button asChild size="lg">
              <Link to="/">Back to home</Link>
            </Button>
            <Button asChild size="lg" variant="secondary">
              <Link to="/projects">View projects</Link>
            </Button>
          </div>
        </div>
      </section>
    </>
  );
}